<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <mask
        id="a"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
    >
        <rect width="100" height="100" rx="50" fill="#CBEAFF" />
    </mask>
    <g mask="url(#a)">
        <rect width="100" height="100" rx="50" fill="#CBEAFF" />
        <path
            d="M46.524 42.81a.432.432 0 0 0 .34-.62c-1.486-3.038-4.298-5.145-8.13-6.11a18.58 18.58 0 0 0-5.372-.54.433.433 0 0 0 .064.863c1.723-.071 3.447.105 5.12.524 3.62.914 6.158 2.813 7.543 5.644a.434.434 0 0 0 .429.239"
            fill="#FFBF40"
        />
        <path
            d="m26.032 32.35-.418 5.95 9.527.8v-.002l2.232-2.377.09-.867-1.906-2.704-9.525-.8Z"
            fill="#FFD45E"
        />
        <path
            d="M30.166 36.668c-.364-.042-.603-.315-.654-.742l1.332.152c-.188.463-.38.624-.678.59Zm1.761-1.195c.177-.448.355-.607.632-.575.45.052.559.465.582.715l-1.214-.14Zm1.944.224c-.009-.87-.522-1.524-1.28-1.61-.976-.112-1.298.695-1.5 1.29l-1.496-.17a1.518 1.518 0 0 1 .924-.875l.144-.053-.458-.733-.094.037c-.594.221-1.066.806-1.25 1.537l-.74-.084-.083.72.742.084c.03.901.557 1.554 1.338 1.65 1.031.12 1.37-.732 1.564-1.31l1.344.155a1.232 1.232 0 0 1-.745.656l-.144.055.444.678.092-.032a1.767 1.767 0 0 0 1.099-1.271l.718.081.08-.72-.7-.085Z"
            fill="#D47829"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M44.57 23.546c-1.195-.673-1.238-.212-2.432-.886s-.886-1.732-2.08-2.406c-1.194-.674-1.502.384-2.697-.29-1.194-.676-.886-1.733-2.08-2.406-1.193-.676-1.503.383-2.697-.291-.597-.338-1.112-1.183-2.424-1.183-1.314 0-1.828.845-2.425 1.183-1.194.674-1.503-.385-2.697.29-1.195.674-.886 1.731-2.08 2.407-1.195.674-1.503-.384-2.698.29-1.193.674-.885 1.732-2.079 2.406-1.195.674-1.236-.014-2.432.66-1.195.675-1.09 2.42-1.054 3.086H45.624c.034-.666.14-2.185-1.054-2.86ZM92.457 32.337c-1.195-.704-1.237-.222-2.432-.927-1.194-.705-.886-1.81-2.08-2.516-1.194-.704-1.502.402-2.697-.302-1.195-.707-.885-1.812-2.08-2.516-1.193-.706-1.503.4-2.697-.305-.597-.352-1.112-1.236-2.424-1.236-1.314 0-1.828.884-2.424 1.236-1.195.705-1.504-.401-2.698.305-1.195.704-.885 1.81-2.08 2.516-1.194.704-1.503-.402-2.698.302-1.193.705-.885 1.811-2.078 2.516-1.195.705-1.238-.014-2.433.69-1.195.706-1.089 2.53-1.054 3.226H93.511c.034-.696.14-2.284-1.054-2.99Z"
            fill="#E1F3FF"
        />
        <g clip-path="url(#b)">
            <path
                d="M52.183 73.628c.238-1.313.182-3.307-.387-4.497-1.25-2.627-3.508-4.03-6.722-3.827-8.008.506-11.61-2.678-15.924-5.428a12.005 12.005 0 0 0-14.405 1.227 12.316 12.316 0 0 0-3.843 6.656 12.427 12.427 0 0 0 .832 7.664c.78 1.66 1.909 3.127 3.309 4.298a12.364 12.364 0 0 0 4.793 2.477c7.78 2.173 18.755.293 27.109-3.458l.056-.024c.494-.227.974-.472 1.455-.69.005.024 3.172-1.341 3.727-4.398Z"
                fill="#E1F3FF"
            />
        </g>
        <path
            d="m60.187 38.977-20.224 3.65-2.635 6.569 28.34-2.605-5.48-7.614Z"
            fill="#8DCEFC"
        />
        <path
            d="m41.759 42.302-1.796.326-2.683 6.693 1.976-.2 2.503-6.819Z"
            fill="#CBEAFF"
        />
        <path
            d="m41.758 42.302 2.813 6.305-1.786.082-1.82-4.275.793-2.112Z"
            fill="#3DA5EB"
        />
        <path
            d="m61.74 46.86-4.853-7.289 2.162-.387 4.986 7.473-2.294.204Z"
            fill="#F9AF2C"
        />
        <path
            d="m16.267 51.008 74.106-6.797S83.353 67.37 70.449 67.63c-26.785.566-48.509.963-48.509.963l-5.673-17.585Z"
            fill="#F9AF2C"
        />
        <path
            d="m19.904 62.271 64.988-5.836a56.676 56.676 0 0 0 3.084-5.997l-69.874 6.266 1.802 5.567Z"
            fill="#EB9600"
        />
        <path
            d="m19.217 60.156 66.96-6.005a63.034 63.034 0 0 0 2.76-5.969L17.427 54.6l1.79 5.556Z"
            fill="#FFD972"
        />
        <g clip-path="url(#c)">
            <path
                d="M29.006 72.554c.143-.85.11-2.14-.233-2.91-.752-1.7-2.11-2.607-4.043-2.476-4.818.327-6.984-1.733-9.58-3.512a6.827 6.827 0 0 0-4.452-1.163c-1.561.143-3.038.829-4.213 1.957-1.175 1.128-1.985 2.638-2.311 4.306a8.599 8.599 0 0 0 .5 4.96 8.083 8.083 0 0 0 1.99 2.78 7.268 7.268 0 0 0 2.884 1.602c4.68 1.406 11.282.19 16.307-2.237l.034-.015c.297-.147.586-.306.875-.447.003.016 1.908-.868 2.242-2.845Z"
                fill="#AEDEFF"
            />
        </g>
        <g clip-path="url(#d)">
            <path
                d="M61.79 74.686c.233-1.26.178-3.171-.38-4.313-1.226-2.52-3.441-3.865-6.594-3.67-7.857.485-11.39-2.57-15.623-5.206a11.992 11.992 0 0 0-14.133 1.176 11.758 11.758 0 0 0-3.77 6.384 11.675 11.675 0 0 0 .816 7.351c.764 1.593 1.873 3 3.246 4.122a12.23 12.23 0 0 0 4.702 2.376c7.633 2.084 18.401.28 26.597-3.317l.055-.022c.485-.218.956-.454 1.427-.662.005.023 3.112-1.287 3.657-4.219Z"
                fill="#8DCEFC"
            />
        </g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M96.6 67.606C89.478 86.532 71.206 100 49.788 100S10.098 86.533 2.976 67.606H96.6Z"
            fill="#8DCEFC"
        />
        <path
            d="M10.94 70.422a.807.807 0 1 0 0 1.614.807.807 0 0 0 0-1.614ZM23.516 70.422a.807.807 0 1 0 0 1.613.807.807 0 0 0 0-1.613ZM36.096 70.422a.806.806 0 1 0 0 1.613.806.806 0 0 0 0-1.613ZM48.675 70.422a.806.806 0 1 0 0 1.613.806.806 0 0 0 0-1.613ZM10.94 86.49a.806.806 0 1 0 0 1.613.806.806 0 0 0 0-1.613ZM23.516 86.49a.806.806 0 1 0 0 1.612.806.806 0 0 0 0-1.612ZM36.096 86.49a.806.806 0 1 0 0 1.612.806.806 0 0 0 0-1.612ZM4.648 78.455a.807.807 0 1 0 0 1.613.807.807 0 0 0 0-1.613ZM17.228 78.455a.807.807 0 1 0 0 1.613.807.807 0 0 0 0-1.613ZM29.813 78.455a.806.806 0 1 0 0 1.613.806.806 0 0 0 0-1.613ZM42.384 78.455a.806.806 0 1 0 0 1.613.806.806 0 0 0 0-1.613ZM87.836 88.103a.807.807 0 1 0 0-1.613.807.807 0 0 0 0 1.614ZM75.26 88.103a.807.807 0 1 0 0-1.613.807.807 0 0 0 0 1.614ZM62.68 88.103a.807.807 0 1 0 0-1.613.807.807 0 0 0 0 1.614ZM50.1 88.103a.806.806 0 1 0 0-1.612.806.806 0 0 0 0 1.612ZM100.416 72.035a.808.808 0 0 0 .57-1.377.809.809 0 0 0-1.24.123.807.807 0 0 0 .67 1.254ZM87.836 72.035a.806.806 0 1 0 0-1.612.806.806 0 0 0 0 1.612ZM75.26 72.035a.806.806 0 1 0 0-1.612.806.806 0 0 0 0 1.612ZM62.68 72.035a.806.806 0 1 0 0-1.612.806.806 0 0 0 0 1.612ZM94.127 80.07a.807.807 0 1 0 0-1.614.807.807 0 0 0 0 1.614ZM81.547 80.07a.807.807 0 1 0 0-1.614.807.807 0 0 0 0 1.614ZM68.963 80.07a.806.806 0 1 0 0-1.612.806.806 0 0 0 0 1.612ZM56.392 80.07a.806.806 0 1 0 0-1.612.806.806 0 0 0 0 1.612ZM67.894 96.606a.806.806 0 1 0 0-1.613.806.806 0 0 0 0 1.613ZM55.315 96.606a.806.806 0 1 0 0-1.613.806.806 0 0 0 0 1.613ZM42.738 96.606a.806.806 0 1 0 0-1.612.806.806 0 0 0 0 1.612ZM30.158 96.606a.806.806 0 1 0 0-1.612.806.806 0 0 0 0 1.612Z"
            fill="#AEDEFF"
        />
    </g>
    <defs>
        <clipPath id="b">
            <path
                fill="#fff"
                transform="matrix(0 1 1 0 10.613 58)"
                d="M0 0h8.976v41.513H0z"
            />
        </clipPath>
        <clipPath id="c">
            <path
                fill="#fff"
                transform="matrix(0 1 1 0 4 62.441)"
                d="M0 0h5.807v24.972H0z"
            />
        </clipPath>
        <clipPath id="d">
            <path
                fill="#fff"
                transform="matrix(0 1 1 0 20 59)"
                d="M0 0h9v39H0z"
            />
        </clipPath>
    </defs>
</svg>
